'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002ecrud$0024$002dOpen$002dTo$002dDelete from "./presto.crud$-Open-To-Delete.js";
import * as $j_presto$002ecrud$0024$002dOpen$002dTo$002dUpdate from "./presto.crud$-Open-To-Update.js";
import * as $j_presto$002ecrud$0024$002dOpen$002dTo$002dView from "./presto.crud$-Open-To-View.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$CrudPage$$anon$17(modalBus$13) {
  this.Kr = null;
  this.Kr = modalBus$13;
}
export { $c_Lpresto_crud$CrudPage$$anon$17 as $c_Lpresto_crud$CrudPage$$anon$17 };
$p = $c_Lpresto_crud$CrudPage$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$CrudPage$$anon$17;
/** @constructor */
function $h_Lpresto_crud$CrudPage$$anon$17() {
}
export { $h_Lpresto_crud$CrudPage$$anon$17 as $h_Lpresto_crud$CrudPage$$anon$17 };
$h_Lpresto_crud$CrudPage$$anon$17.prototype = $p;
$p.afS = (function(item) {
  var this$2 = this.Kr;
  var event = new $j_presto$002ecrud$0024$002dOpen$002dTo$002dView.$c_Lpresto_crud$OpenToView(item);
  this$2.bp.aw(event);
});
$p.sW = (function(item) {
  var this$2 = this.Kr;
  var event = new $j_presto$002ecrud$0024$002dOpen$002dTo$002dUpdate.$c_Lpresto_crud$OpenToUpdate(item);
  this$2.bp.aw(event);
});
$p.sy = (function(item) {
  var this$2 = this.Kr;
  var event = new $j_presto$002ecrud$0024$002dOpen$002dTo$002dDelete.$c_Lpresto_crud$OpenToDelete(item);
  this$2.bp.aw(event);
});
$p.nP = (function(event) {
  this.Kr.bp.aw(event);
});
var $d_Lpresto_crud$CrudPage$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$CrudPage$$anon$17, "presto.crud$CrudPage$$anon$17", ({
  Vk: 1,
  Vp: 1
}));
export { $d_Lpresto_crud$CrudPage$$anon$17 as $d_Lpresto_crud$CrudPage$$anon$17 };
//# sourceMappingURL=presto.crud$-Crud-Page$$anon$17.js.map
